import { render, staticRenderFns } from "./RateOptionsButton.vue?vue&type=template&id=22212b21&lang=pug&"
import script from "./RateOptionsButton.vue?vue&type=script&lang=ts&"
export * from "./RateOptionsButton.vue?vue&type=script&lang=ts&"
import style0 from "./RateOptionsButton.vue?vue&type=style&index=0&id=22212b21&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports